<div class="column">
  <div class="row">
    <div class="search">
      <mat-icon matPrefix svgIcon="search" color="accent"></mat-icon>
      <input type="search" placeholder="Search by ID, Name or City"
        class='mat-body secondary-border-element background-text-element text-input' [formControl]='search'
        list='searchDataList' #searchInput tabindex="1">
      </div>

      <div class="country-filter">
        <button mat-button [matMenuTriggerFor]="filterCountry">
          <span class='mat-body flex-center'><span class='v-middle'>{{getShownCountry()}}</span>
          <mat-icon svgIcon="dropdownMenu" class="secondary-contrast-icon"></mat-icon>
        </span>
      </button>
      <mat-menu #filterCountry="matMenu" xPosition="before">
        @for (countryID of CountriesIDs | keyvalue; track countryID) {
          <button
            (click)="setCountryFilter(countryID.value)"
          mat-menu-item>{{this.getFullCountryNameById(countryID.value)}}</button>
        }
      </mat-menu>
    </div>
    <div class="spacer"></div>

    <button mat-raised-button color="accent" (click)="generateReleaseCodes()">Generate Release Codes</button>
  </div>
  <app-patient-manager-table #patientManagerTable></app-patient-manager-table>
</div>


<p class="mat-small background-text-element version">Prototype:&nbsp;v{{patient_manager_version}}&nbsp;|&nbsp;Environment:
{{environmentName}}&nbsp;|&nbsp;Build datetime: {{buildDateTime|date:'MM/dd/yyyy, h:mm a'}}</p>